import React, { useState, useEffect } from 'react';
import '../../../../Customer/Menu/NavBar/navBar.css';
import ApiService from '../../../../services/apiService';
import '../menuItemcard.css';
import { useNavigate } from 'react-router';
import './catNav.css';

const CategoryNavBar = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categorymenu, setCategoryMenu] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    GetCategory();
  }, []);

  const GetCategory = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService();
      let res = await apiService.get('GET_CATEGORY_MASTER');

      console.log('Raw category API response:', res?.data?.result);

      if (res?.data?.result && Array.isArray(res.data.result)) {
        // Filter active categories and ensure proper data structure
        const filteredCategories = res.data.result.filter((item) => {
          // Check if item has required properties
          const hasValidId = item?.recordId !== null && item?.recordId !== undefined;
          const hasValidName = item?.catName || item?.name; // catName is primary in your API
          const isActive = item?.active === 1 || item?.active === true; // active = 1 means active

          console.log('Category check:', {
            name: hasValidName,
            id: hasValidId,
            active: isActive,
            item: item,
          });

          return hasValidId && hasValidName && isActive;
        });

        console.log('Filtered categories:', filteredCategories);
        setCategories(filteredCategories);
      } else {
        console.warn('No categories found or invalid response structure');
        setCategories([]);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryClick = async (selectedCategoryId) => {
    try {
      setLoading(true);
      const apiService = new ApiService();
      let parameters = `?CategoryId=${selectedCategoryId}`;
      let res = await apiService.getApiParamater('GET_MENU', parameters);

      console.log('Menu API response for category:', selectedCategoryId, res?.data);

      if (res?.data?.statusCode === 200) {
        setCategoryMenu(res?.data?.result);
        navigate('/admin/menu', { state: { categorymenu: res?.data?.result } });
      } else if (res?.data?.statusCode === 204) {
        setCategoryMenu([]); // Clear menu state
        navigate('/admin/menu', { state: { categorymenu: [] } }); // Navigate with empty array
      } else {
        console.error('Error fetching menu by category:', res?.data?.message);
        setCategoryMenu([]);
        navigate('/admin/menu', { state: { categorymenu: [] } });
      }
    } catch (error) {
      console.error('Error fetching menu by category:', error);
      setCategoryMenu([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubCategoryClick = async (selectedSubCatId) => {
    try {
      setLoading(true);
      const apiService = new ApiService();
      let parameters = `?SubCategoryId=${selectedSubCatId}`;
      let res = await apiService.getApiParamater('GET_MENU', parameters);

      console.log('Menu API response for subcategory:', selectedSubCatId, res?.data);

      if (res?.data?.statusCode === 200) {
        setCategoryMenu(res?.data?.result);
        navigate('/admin/menu', { state: { categorymenu: res?.data?.result } });
      } else {
        console.error('Error fetching menu by subcategory:', res?.data?.message);
        setCategoryMenu([]);
        navigate('/admin/menu', { state: { categorymenu: [] } });
      }
    } catch (error) {
      console.error('Error fetching menu by subcategory:', error);
      setCategoryMenu([]);
    } finally {
      setLoading(false);
    }
  };

  const handlemenu = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService();
      let res = await apiService.get('GET_MENU');

      if (res?.data?.statusCode === 200) {
        setCategoryMenu(res?.data?.result);
        navigate('/admin/menu', { state: { categorymenu: res?.data?.result } });
      } else {
        console.error('Error fetching all menu items:', res?.data?.message);
        setCategoryMenu([]);
        navigate('/admin/menu', { state: { categorymenu: [] } });
      }
    } catch (error) {
      console.error('Error fetching all menu items:', error);
      setCategoryMenu([]);
    } finally {
      setLoading(false);
    }

    setSubCategories([]);
    setSelectedCategory('');
    setIsDropdownOpen(null);
  };

  const GetSubCategory = async (categoryId) => {
    try {
      const apiService = new ApiService();
      let parameters = `?CategoryId=${categoryId}`;
      let res = await apiService.getApiParamater('GET_SUB_CATEGORY_MASTER', parameters);

      console.log('Subcategory API response:', res?.data);

      if (res?.data?.result && Array.isArray(res.data.result)) {
        // Ensure subcategories have proper structure
        const validSubCategories = res.data.result.filter((subCat) => {
          const hasValidId = subCat?.recordid !== null && subCat?.recordid !== undefined;
          const hasValidName = subCat?.name || subCat?.subcatname; // Support both name formats
          return hasValidId && hasValidName;
        });

        setSubCategories(validSubCategories);
      } else {
        setSubCategories([]);
      }
    } catch (error) {
      console.error('Error fetching subcategory data:', error);
      setSubCategories([]);
    }
  };

  const handleCategoryToggle = (categoryId) => {
    setSelectedCategory(categoryId);
    handleCategoryClick(categoryId);

    if (isDropdownOpen === categoryId) {
      setIsDropdownOpen(null);
      setSubCategories([]);
    } else {
      setIsDropdownOpen(categoryId);
      GetSubCategory(categoryId);
    }
  };

  const handleDocumentClick = (event) => {
    if (!event.target.closest('.nav-item')) {
      setIsDropdownOpen(null);
    }
  };

  // Helper function to get display name
  const getCategoryName = (category) => {
    return category?.catName || category?.name || 'Unknown Category';
  };

  const getSubCategoryName = (subCategory) => {
    return subCategory?.subcatname || subCategory?.name || 'Unknown Subcategory';
  };

  if (loading && categories.length === 0) {
    return (
      <div className="maoin-BG">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center p-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading categories...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="maoin-BG">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ul className="nav nav-pills overslid d-flex justify-content-between" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${!selectedCategory ? 'active' : ''}`}
                  onClick={handlemenu}
                  data-bs-toggle="pill"
                  type="button"
                  role="tab"
                  disabled={loading}
                >
                  {loading ? 'Loading...' : 'All Items'}
                </button>
              </li>

              {categories?.length > 0 ? (
                categories.map((category, key) => {
                  const categoryName = getCategoryName(category);
                  const sanitizedName = categoryName.replace(/\s+/g, '-');

                  return (
                    <li className="nav-item" role="presentation" key={category.id || key}>
                      <button
                        className={`nav-link ${selectedCategory === category.id ? 'active' : ''}`}
                        onClick={() => handleCategoryToggle(category.recordId)}
                        id={`pills-${sanitizedName}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#pills-${sanitizedName}`}
                        type="button"
                        role="tab"
                        aria-controls={`pills-${sanitizedName}`}
                        aria-selected={selectedCategory === category.id ? 'true' : 'false'}
                        disabled={loading}
                        title={categoryName} // Tooltip for full name
                      >
                        {categoryName}
                      </button>

                      {isDropdownOpen === category.recordid && subCategories?.length > 0 && (
                        <div className="subcategories-dropdown">
                          {subCategories.map((subCategory, subKey) => {
                            const subCategoryName = getSubCategoryName(subCategory);

                            return (
                              <div
                                className="subcategories-dropdown-div"
                                key={subCategory.recordid || subKey}
                                onClick={() => handleSubCategoryClick(subCategory.recordid)}
                                title={subCategoryName}
                              >
                                {subCategoryName}
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {isDropdownOpen === category.id && subCategories?.length === 0 && (
                        <div className="subcategories-dropdown">
                          <div className="subcategories-dropdown-div text-muted">No subcategories available</div>
                        </div>
                      )}
                    </li>
                  );
                })
              ) : (
                <li className="nav-item">
                  <span className="nav-link text-muted">No categories available</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryNavBar;
